module.exports = __webpack_public_path__ + "static/Wilma-208c2a05e3c5f48e6b3ea2b01e5c716f.jpg";